import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    technologies: Array,
  }

  connect() {
    let _this = this
    $(this.inputTarget).autocomplete({
      minChars: 1,
      autoSelectFirst: true,
      triggerSelectOnValidInput: false,
      formatResult: function(suggestion) {
        return `<div><strong>${suggestion.value}</strong> ${suggestion.category}</div>`
      },
      lookup: function(query, done) {
        var items = []
        _this.technologiesValue.forEach(function(tech) {
          if (tech.name.toLowerCase().includes(query.toLowerCase())) {
            items.push({
              value: tech.display_name,
              category: tech.display_category,
              slug: tech.slug
            })
          }
        })
        done({suggestions: items})
      },
      onSelect: function (suggestion) {
        Turbo.visit(`/technologies/${suggestion.slug}`)
      }
    })
  }
}
